import { TypedAnalyticsEvent } from "@services/tracking/types/analyticsEvent";
import { BannerImpressionTrackingInfo } from "@services/tracking/types/trackingInfo/bannerImpressionTrackingInfo";

import { GoogleAnalyticsEvents } from "../GoogleAnalyticsEvents";
import {
    GoogleAnalyticsMinimumDataset,
    getPageInfo,
    getUserInfo,
} from "../GoogleAnalyticsMinimumDataset";

export interface GoogleAnalyticsBannerImpression
    extends GoogleAnalyticsMinimumDataset {
    info: {
        name: string;
        placement: string;
        type: string;
        targeturl: string;
        targetname: string;
    };
}

const getGoogleAnalyticsBannerImpression = (
    data: TypedAnalyticsEvent<BannerImpressionTrackingInfo>,
    event: GoogleAnalyticsEvents = GoogleAnalyticsEvents.BannerImpression,
): GoogleAnalyticsBannerImpression => {
    const eventData: BannerImpressionTrackingInfo =
        data?.payload.eventData || {};

    return {
        event,
        pageInfo: getPageInfo(data),
        userInfo: getUserInfo(data),
        info: {
            name: eventData.name || "",
            placement: eventData.placement || "",
            type: eventData.type || "",
            targeturl: eventData.targetUrl || "",
            targetname: eventData.targetName || "",
        },
    };
};

export { getGoogleAnalyticsBannerImpression };
